// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import routes from './routes';
import { useTheme } from './utils/hooks';

// Global styles are imported here
import './styles/minimal.css'; // Base styles, layout, etc.
import './styles/header.css'; // Header/footer styles

/**
 * Main App component
 * Uses centralized route configuration and shared layout
 */
function App() {
  // Initialize the theme hook. This will apply the initial theme
  // (from localStorage or system preference) to the document.documentElement.
  // We don't need to use the returned 'theme' or 'toggleTheme' here
  // as the ThemeSwitcher component will handle user interactions.
  useTheme();

  return (
    <Router>
      {/* The 'app-container' class is managed by the Layout component in your setup,
          or you can ensure it's on a top-level div here if needed.
          Based on your Layout.js, it already adds 'app-container'.
          So, no need for an extra one here. */}
      <Routes>
        {routes.map(route => (
          <Route key={route.path} path={route.path} element={route.component} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;